module.exports = "/_next/static/resources/pack-4ad48abc866210f3ad461c6435d3c848.webp";